import React, { Component } from 'react';
import moment from 'moment-jalaali';
import { DayPickerSingleDateController } from 'react-dates'
import TimeField from 'react-simple-timefield';
import { creatStartEnd } from '../api/timeListProcess'
class Recorddata extends Component {

  constructor(props){
    super(props)
    this.state = Object.assign( {}, this.props.time )
    this.state.start = moment(this.state.start).locale('en');
    this.state.end = moment(this.state.end).locale('en');
    this.startInput = this.state.start.format('HH:mm')
    this.endInput = this.state.end.format('HH:mm')
    this.updateRecordData = this.updateRecordData.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  updateRecordData(){
    if( moment(this.props.time.start).locale('en').format('HH:mm') !== this.startInput || 
      moment(this.props.time.end).locale('en').format('HH:mm') !== this.endInput || 
      moment(this.props.time.start).locale('en').format('YYYY/MM/DD') !== this.state.start.locale('en').format('YYYY/MM/DD') ){

      const sendObj = Object.assign({}, this.state, creatStartEnd(this.startInput, this.endInput, this.state.start))
      this.props.updateRecord(sendObj)

    }
  }

  handleSubmit(e){
    e.preventDefault()
  }

  handleDateChange(date){
    if(date.format('YYYY/MM/DD') !== this.state.start.format('YYYY/MM/DD')){
      const breakTime = this.startInput.split(':');
      const newDate = date.set({hours:breakTime[0], minute:breakTime[1], second:0})
      this.setState({start : newDate})
    }
  }

  componentWillReceiveProps(newProps, newState){
    if(newProps.open !== this.props.open && !newProps.open){
      this.updateRecordData()
    }
  }

  handleKeyPress(e){
    if(e.key === 'Enter'){
      this.updateRecordData()
    }
  }

  render() {

    this.startDay = moment(this.state.start).locale('fa').format('jD jMMMM')
    return (
      (this.props.open)?(
          <div className="record-data">
            <div className="record-data-overlayer" onClick={this.props.toggle}></div>
            <div className="record-data-body">
              <div className="record-data-detail">
                <form onSubmit={this.updateRecordData} onKeyPress={this.handleKeyPress}>
                  <div className="pull-right">
                    <h6>شروع
                      {' '}
                      <i>
                        ({this.startDay})
                      </i>
                    </h6>
                      <TimeField value={this.startInput} onChange={(value)=>{this.startInput=value}} />
                  </div>
                  <div className="pull-left">
                    <h6>پایان</h6>
                    <TimeField value={this.endInput} onChange={(value)=>{this.endInput=value}} />
                  </div>
                </form>
              </div>
              <div className="clearfix"></div>
              <div className="record-data-calender">
                <DayPickerSingleDateController
                  isRTL
                  numberOfMonths={1}
                  renderMonth={month => moment(month).format('jMMMM jYYYY')}
                  renderDayContents={day => moment(day).format('jD')}
                  hideKeyboardShortcutsPanel
                  monthFormat="jYYYYjMMMM"
                  date={this.state.start}
                  onDateChange={day => this.handleDateChange(day)}
                />
              </div>
            </div>
          </div>
      ):(null)
    );
  }
}

Recorddata.defaultProps = {
  time:{
    project:{}
  }
}
export default Recorddata;
